import React from 'react';
import Navbar from '../HomeComponent/Navbar';
import FooterComponent from '../Footer/FooterComponent';

const Features = () => {
    const featureList = [
        {
            title: "Human-Like Voice AI",
            desc: "Our agents speak with natural intonation, pauses, and emotion, making them indistinguishable from human callers."
        },
        {
            title: "Multi-Channel Support",
            desc: "Deploy agents across Phone, Web Chat, SMS, and WhatsApp from a single platform."
        },
        {
            title: "CRM Integration",
            desc: "Seamlessly sync calls, transcripts, and lead data with Salesforce, HubSpot, Zoho, and more."
        },
        {
            title: "Real-Time Analytics",
            desc: "Monitor call performance, sentiment analysis, and conversion rates live on your dashboard."
        },
        {
            title: "Custom Workflows",
            desc: "Build complex conversation flows with our drag-and-drop editor. No coding required."
        },
        {
            title: "24/7 Availability",
            desc: "Never miss a lead. Your AI workforce runs around the clock, handling thousands of concurrent calls."
        }
    ];

    return (
        <>
            <Navbar />
            <div style={{ paddingTop: '100px', minHeight: '100vh', background: '#ffffff', paddingBottom: '60px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <h1 style={{ fontSize: '3rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '16px' }}>
                            Features that Empower Your Business
                        </h1>
                        <p style={{ fontSize: '1.25rem', color: '#64748b', maxWidth: '700px', margin: '0 auto' }}>
                            Everything you need to automate your customer interactions and scale your operations.
                        </p>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '40px' }}>
                        {featureList.map((feature, index) => (
                            <div key={index} style={{
                                padding: '30px',
                                borderRadius: '16px',
                                backgroundColor: '#f8fafc',
                                border: '1px solid #e2e8f0',
                                transition: 'all 0.3s ease'
                            }}>
                                <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#334155', marginBottom: '12px' }}>
                                    {feature.title}
                                </h3>
                                <p style={{ color: '#64748b', lineHeight: '1.6' }}>
                                    {feature.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <FooterComponent />
        </>
    );
};

export default Features;
